import { render, staticRenderFns } from "./ThgOverview.vue?vue&type=template&id=6165604c&scoped=true"
import script from "./ThgOverview.vue?vue&type=script&lang=ts"
export * from "./ThgOverview.vue?vue&type=script&lang=ts"
import style0 from "./ThgOverview.vue?vue&type=style&index=0&id=6165604c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6165604c",
  null
  
)

export default component.exports